<template>
  <div class="im-auto-reply-page">
    <!-- 区块1：全局配置 + 运行状态（左右并列） -->
    <el-row :gutter="16" style="margin-bottom: 16px;">
      <el-col :span="12">
        <el-card class="top-card">
          <div slot="header" class="card-header">
            <span>美团 IM 自动回复</span>
            <div style="display:flex;align-items:center;gap:10px;">
              <el-select v-model="selectedBrand" placeholder="选择通道" size="small" style="width: 140px;" @change="onBrandChange">
                <el-option v-for="b in brands" :key="b._id" :label="b.brand" :value="b.brand"></el-option>
              </el-select>
              <el-button type="primary" size="small" @click="handleSave" :loading="saving">保存配置</el-button>
            </div>
          </div>
          <el-alert
            type="info"
            :closable="false"
            show-icon
            style="margin-bottom: 12px;"
            title="本页按采集通道（大账号）组织白名单"
            description="下拉为独立品牌（即采集大账号），门店列表仅含该通道已采集大盘数据的运营中门店。新通道需先触发大盘采集。"
          ></el-alert>
          <el-form label-width="140px">
            <el-form-item label="全局默认回复文案">
              <el-input
                type="textarea"
                :rows="3"
                v-model="config.defaultReplyText"
                placeholder="所有未单独配置文案的门店使用此默认值"
                maxlength="200"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="top-card">
          <div slot="header" class="card-header">
            <span>运行状态（实时查询）</span>
            <div>
              <el-button size="small" @click="fetchStatus" :loading="statusLoading">刷新状态</el-button>
              <el-button size="small" type="warning" @click="handleRestart" :loading="restarting">重启注入</el-button>
            </div>
          </div>
          <div v-if="status" class="status-block">
            <el-row :gutter="16">
              <el-col :span="12"><div class="stat-item">进程状态: <b :class="'state-' + status.process.state.toLowerCase()">{{ status.process.state }}</b></div></el-col>
              <el-col :span="12"><div class="stat-item">CDP 连接: <b>{{ status.process.cdpConnected ? '✓' : '✗' }}</b></div></el-col>
            </el-row>
            <el-row :gutter="16" style="margin-top: 12px;">
              <el-col :span="12"><div class="stat-item">CDP 地址: <b>{{ status.process.cdpEndpoint || '-' }}</b></div></el-col>
              <el-col :span="12"><div class="stat-item">采集端: <b>{{ currentCollector ? currentCollector.name : '-' }}</b></div></el-col>
            </el-row>
            <el-row :gutter="16" style="margin-top: 12px;">
              <el-col :span="24"><div class="stat-item">采集端URL: {{ currentCollector ? currentCollector.url : '-' }}</div></el-col>
            </el-row>
            <el-row :gutter="16" style="margin-top: 12px;">
              <el-col :span="12"><div class="stat-item">运行时长: {{ formatUptime(status.process.uptimeMs) }}</div></el-col>
              <el-col :span="12"><div class="stat-item">监听器: <b>{{ status.listener.installed ? '✓已安装' : '✗未安装' }}</b></div></el-col>
            </el-row>
            <el-row :gutter="16" style="margin-top: 12px;">
              <el-col :span="12"><div class="stat-item">SDK 就绪: <b>{{ status.listener.extraInstanceReady ? '✓' : '✗' }}</b></div></el-col>
              <el-col :span="12"><div class="stat-item">白名单门店: {{ status.listener.whitelistCount }}</div></el-col>
            </el-row>
            <el-row :gutter="16" style="margin-top: 12px;">
              <el-col :span="12"><div class="stat-item">白名单门店: {{ status.listener.whitelistCount }}</div></el-col>
              <el-col :span="12"></el-col>
            </el-row>
            <div v-if="status.listener.stats" class="stats-row" style="margin-top: 12px;">
              统计: 收到 {{ status.listener.stats.received }} |
              顾客消息 {{ status.listener.stats.customerMsgs }} |
              白名单内 {{ status.listener.stats.inWhitelist }} |
              已回复 {{ status.listener.stats.replied }} |
              跳过 {{ status.listener.stats.skipped }} |
              错误 {{ status.listener.stats.errors }}
            </div>
            <div v-if="status.process.lastError" class="error-row" style="margin-top: 12px; color: #f56c6c;">
              最近错误: {{ status.process.lastError }}
            </div>
            <div v-if="status.listener.evaluateError" class="error-row" style="margin-top: 12px; color: #f56c6c;">
              监听器探测异常: {{ status.listener.evaluateError }}
            </div>
          </div>
          <div v-else style="color: #999;">点击「刷新状态」查看采集端 IM 运行情况</div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 区块2：门店白名单 -->
    <el-card style="margin-bottom: 16px;">
      <div slot="header" class="card-header">
        <span class="header-title">
          门店白名单
          <span class="store-count-summary">共 {{ config.rules.length }} 家，开启 {{ enabledCount }} 家</span>
        </span>
        <div>
          <el-button type="warning" size="small" @click="handleAutoCreate" :loading="autoCreating">自动创建门店</el-button>
          <el-button type="success" size="small" @click="handleEnableAll">全部开启</el-button>
          <el-button type="danger" size="small" @click="handleDisableAll">全部关闭</el-button>
          <el-button type="primary" size="small" @click="handleAddStore">新增门店</el-button>
        </div>
      </div>
      <!-- 搜索栏（纯前端筛选） -->
      <div class="search-bar">
        <el-input
          v-model="searchKeyword"
          placeholder="搜索门店名 / 项目名 / wmPoiId"
          clearable
          prefix-icon="el-icon-search"
          size="small"
          style="width: 300px;"
        ></el-input>
        <el-select
          v-model="searchStatus"
          placeholder="开关状态"
          clearable
          size="small"
          style="width: 140px;"
        >
          <el-option label="已开启" value="true"></el-option>
          <el-option label="已关闭" value="false"></el-option>
        </el-select>
        <span class="search-count" v-if="searchKeyword || searchStatus !== ''">
          筛选结果：{{ filteredRules.length }} / {{ config.rules.length }}
        </span>
      </div>

      <el-table :data="filteredRules" border stripe v-loading="loading" empty-text="暂无白名单门店">
        <el-table-column label="门店名称" min-width="200">
          <template slot-scope="scope">
            <div style="font-size:14px;color:#333;font-weight:600;">{{ scope.row.projectName || '（未关联项目）' }}</div>
            <div style="color:#909399;font-size:12px;">{{ scope.row.poiName }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="wmPoiId" label="wmPoiId" width="140"></el-table-column>
        <el-table-column label="回复开关" width="100" align="center">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.enabled"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="回复文案(覆盖)" min-width="240">
          <template slot-scope="scope">
            <span class="reply-summary" @click="openTextEdit(scope.row)">
              {{ scope.row.replyText || '(用默认)' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="备注" width="140">
          <template slot-scope="scope">
            <el-input v-model="scope.row.remark" size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="openTextEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleRemoveStore(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增门店弹窗 -->
    <el-dialog title="新增门店到白名单" :visible.sync="addDialogVisible" width="520px">
      <el-form label-width="100px">
        <el-form-item label="添加方式">
          <el-radio-group v-model="addMode">
            <el-radio label="select">从门店选择</el-radio>
            <el-radio label="manual">手动输入</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 从门店选择 -->
        <el-form-item v-if="addMode === 'select'" label="选择门店">
          <el-select
            v-model="selectedStoreCode"
            filterable
            remote
            placeholder="输入门店名称搜索"
            :remote-method="searchStore"
            :loading="storeSearching"
            style="width: 100%;"
          >
            <el-option
              v-for="s in storeOptions"
              :key="s._id"
              :label="(s.projectName ? s.projectName + ' / ' : '') + s.name + ' (' + s.meituanCode + ')'"
              :value="s.meituanCode"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 手动输入 -->
        <template v-if="addMode === 'manual'">
          <el-form-item label="wmPoiId">
            <el-input v-model="manualCode" placeholder="请输入美团门店ID" style="width: 100%;"></el-input>
          </el-form-item>
          <el-form-item label="门店名称">
            <el-input v-model="manualName" placeholder="请输入门店名称" style="width: 100%;"></el-input>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAddStore">添加</el-button>
      </div>
    </el-dialog>

    <!-- 文案编辑弹窗 -->
    <el-dialog
      :title="'编辑回复文案 - ' + textEditStoreName"
      :visible.sync="textEditVisible"
      width="600px"
      @closed="onTextEditClosed"
    >
      <el-form label-width="0">
        <el-form-item>
          <el-input
            type="textarea"
            :rows="5"
            v-model="textEditValue"
            placeholder="留空则使用全局默认文案"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
        <div class="text-edit-hint">
          <span class="text-edit-default">{{ '当前全局默认：' + (config.defaultReplyText ? truncate(config.defaultReplyText, 30) : '(未设置)') }}</span>
        </div>
      </el-form>
      <div slot="footer">
        <el-button @click="textEditVisible = false">取消</el-button>
        <el-button type="warning" plain @click="clearTextEdit">清空(用默认)</el-button>
        <el-button type="primary" @click="saveTextEdit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ImAutoReply',
  data () {
    return {
      loading: false,
      saving: false,
      statusLoading: false,
      restarting: false,
      autoCreating: false,
      brands: [],
      selectedBrand: '',
      config: {
        defaultReplyText: '',
        rules: []
      },
      status: null,
      // 新增门店弹窗
      addDialogVisible: false,
      addMode: 'select',
      selectedStoreCode: '',
      manualCode: '',
      manualName: '',
      storeOptions: [],
      storeSearching: false,
      allStores: [],
      // 文案编辑弹窗
      textEditVisible: false,
      textEditIndex: -1, // 当前编辑的 rules 下标
      textEditValue: '', // 弹窗内输入的文案（临时，确认才写回）
      textEditStoreName: '', // 弹窗标题显示的门店名
      // 白名单搜索关键词（纯前端筛选）
      searchKeyword: '',
      // 开关状态筛选：'' 全部 / 'true' 已开启 / 'false' 已关闭
      searchStatus: ''
    }
  },
  computed: {
    // 当前品牌的采集端信息（服务器名称 + URL）
    currentCollector () {
      const b = this.brands.find(b => b.brand === this.selectedBrand)
      return b && b.collectorId ? b.collectorId : null
    },
    // 已开启自动回复的门店数量
    enabledCount () {
      return this.config.rules.filter(r => r.enabled).length
    },
    // 白名单前端筛选：支持按开关状态 + 项目名 / 门店名 / wmPoiId 过滤
    filteredRules () {
      let list = this.config.rules
      // 按开关状态筛选
      if (this.searchStatus !== '') {
        const enabled = this.searchStatus === 'true'
        list = list.filter(r => r.enabled === enabled)
      }
      // 按关键词筛选
      if (this.searchKeyword) {
        const kw = this.searchKeyword.toLowerCase().trim()
        list = list.filter(r =>
          (r.projectName || '').toLowerCase().includes(kw) ||
          (r.poiName || '').toLowerCase().includes(kw) ||
          String(r.wmPoiId || '').toLowerCase().includes(kw)
        )
      }
      return list
    }
  },
  created () {
    this.fetchBrands()
  },
  methods: {
    // 获取通道列表（仅独立品牌 = 采集大账号）
    async fetchBrands () {
      try {
        const { data: res } = await this.$http.get('yunwei/brand/list', { params: { enabled: true, standalone: 1 } })
        if (res.meta.status === 200) {
          this.brands = res.data.list || []
          if (this.brands.length > 0) {
            this.selectedBrand = this.brands[0].brand
            this.fetchConfig()
          }
        }
      } catch (e) { /* 忽略 */ }
    },

    // 品牌切换时重新加载配置
    onBrandChange () {
      this.fetchConfig()
    },

    async fetchConfig () {
      this.loading = true
      try {
        const { data: res } = await this.$http.get('yunwei/imAutoReply/config', {
          params: { brand: this.selectedBrand }
        })
        if (res.meta.status === 200) {
          this.config.defaultReplyText = res.data.defaultReplyText || ''
          this.config.rules = res.data.rules || []
        } else {
          this.$message.error(res.meta.msg || '获取配置失败')
        }
      } catch (err) {
        this.$message.error('获取配置失败')
      } finally {
        this.loading = false
      }
    },

    async handleSave () {
      if (this.config.defaultReplyText.length > 200) {
        return this.$message.error('默认文案不能超过200字')
      }
      for (let i = 0; i < this.config.rules.length; i++) {
        if (this.config.rules[i].replyText && this.config.rules[i].replyText.length > 200) {
          return this.$message.error(`第${i + 1}条门店文案超过200字`)
        }
      }
      this.saving = true
      try {
        const { data: res } = await this.$http.put('yunwei/imAutoReply/config', {
          brand: this.selectedBrand,
          defaultReplyText: this.config.defaultReplyText,
          rules: this.config.rules
        })
        if (res.meta.status === 200) {
          this.$message.success('保存成功，已推送采集端')
          this.fetchConfig()
        } else {
          this.$message.error(res.meta.msg || '保存失败')
        }
      } catch (err) {
        this.$message.error('保存失败')
      } finally {
        this.saving = false
      }
    },

    async handleAddStore () {
      this.selectedStoreCode = ''
      this.manualCode = ''
      this.manualName = ''
      this.addMode = 'select'
      this.addDialogVisible = true
      // 预加载全部门店（数据量不大时）
      await this.searchStore('')
    },

    async searchStore (query) {
      this.storeSearching = true
      try {
        const { data: res } = await this.$http.get('yunwei/imAutoReply/storeOptions', {
          params: { brand: this.selectedBrand }
        })
        if (res.meta.status === 200) {
          this.allStores = res.data || []
          if (query) {
            this.storeOptions = this.allStores.filter(s =>
              (s.name || '').includes(query) || String(s.meituanCode || '').includes(query)
            )
          } else {
            this.storeOptions = this.allStores
          }
        }
      } catch (err) {
        // 忽略
      } finally {
        this.storeSearching = false
      }
    },

    confirmAddStore () {
      if (this.addMode === 'select') {
        // 门店选择模式
        if (!this.selectedStoreCode) {
          return this.$message.warning('请选择门店')
        }
        if (this.config.rules.some(r => r.wmPoiId === this.selectedStoreCode)) {
          return this.$message.warning('该门店已在白名单中')
        }
        const store = this.allStores.find(s => s.meituanCode === this.selectedStoreCode)
        this.config.rules.push({
          wmPoiId: this.selectedStoreCode,
          poiName: store ? store.name : '',
          projectName: store ? (store.projectName || '') : '',
          enabled: true,
          replyText: '',
          remark: ''
        })
      } else {
        // 手动输入模式
        if (!this.manualCode.trim()) {
          return this.$message.warning('请输入 wmPoiId')
        }
        if (this.config.rules.some(r => r.wmPoiId === this.manualCode.trim())) {
          return this.$message.warning('该门店已在白名单中')
        }
        this.config.rules.push({
          wmPoiId: this.manualCode.trim(),
          poiName: this.manualName.trim(),
          enabled: true,
          replyText: '',
          remark: ''
        })
      }
      this.addDialogVisible = false
      this.$message.success('已添加，记得点击「保存配置」生效')
    },

    handleRemoveStore (row) {
      // 按 wmPoiId 查找真实下标（搜索筛选后 scope.$index 不再可靠）
      const index = this.config.rules.findIndex(r => r.wmPoiId === row.wmPoiId)
      if (index < 0) return
      this.config.rules.splice(index, 1)
    },

    // 自动创建门店：批量导入运营中店铺的美团账号到白名单（仅加内存，需手动保存）
    async handleAutoCreate () {
      try {
        await this.$confirm('将批量导入所有运营中店铺的美团账号到白名单（已存在的不会重复添加），是否继续？', '自动创建门店', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        })
      } catch (e) {
        return
      }
      this.autoCreating = true
      try {
        const { data: res } = await this.$http.get('yunwei/imAutoReply/storeOptions', {
          params: { brand: this.selectedBrand }
        })
        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg || '获取门店列表失败')
          return
        }
        const candidates = res.data || []
        // 通道未采集：门店候选为空，明确提示运维先采集
        if (candidates.length === 0) {
          this.$message.warning('该通道尚未采集大盘数据，无运营中门店可配置，请先在「大盘数据采集」页触发一次采集')
          return
        }
        // 过滤已在白名单中的门店
        const existingIds = new Set(this.config.rules.map(r => r.wmPoiId))
        const newRules = candidates
          .filter(s => !existingIds.has(s.meituanCode))
          .map(s => ({
            wmPoiId: s.meituanCode,
            poiName: s.name,
            projectName: s.projectName || '',
            enabled: false,
            replyText: '',
            remark: ''
          }))
        if (newRules.length === 0) {
          this.$message.info('该通道运营中门店已在白名单中，无需新增')
          return
        }
        this.config.rules.push(...newRules)
        this.$message.success(`已添加 ${newRules.length} 家门店，请点击「保存配置」生效`)
      } catch (err) {
        this.$message.error('获取门店列表失败')
      } finally {
        this.autoCreating = false
      }
    },

    // 全部开启：白名单中所有门店 enabled=true（仅改内存，需手动保存）
    async handleEnableAll () {
      if (this.config.rules.length === 0) {
        return this.$message.warning('白名单为空')
      }
      const disabledCount = this.config.rules.filter(r => !r.enabled).length
      if (disabledCount === 0) {
        return this.$message.info('所有门店已处于开启状态')
      }
      try {
        await this.$confirm(`确定开启白名单中所有 ${this.config.rules.length} 家门店的自动回复？`, '全部开启', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        return
      }
      this.config.rules.forEach(r => { r.enabled = true })
      this.$message.success(`已开启 ${disabledCount} 家门店，请点击「保存配置」生效`)
    },

    // 全部关闭：白名单中所有门店 enabled=false（仅改内存，需手动保存）
    async handleDisableAll () {
      if (this.config.rules.length === 0) {
        return this.$message.warning('白名单为空')
      }
      const enabledCount = this.config.rules.filter(r => r.enabled).length
      if (enabledCount === 0) {
        return this.$message.info('所有门店已处于关闭状态')
      }
      try {
        await this.$confirm(`确定关闭白名单中所有 ${this.config.rules.length} 家门店的自动回复？`, '全部关闭', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        return
      }
      this.config.rules.forEach(r => { r.enabled = false })
      this.$message.success(`已关闭 ${enabledCount} 家门店，请点击「保存配置」生效`)
    },

    // ===== 门店定制文案编辑 =====
    /** 打开文案编辑弹窗（传入 row，内部按 wmPoiId 定位真实下标） */
    openTextEdit (row) {
      const index = this.config.rules.findIndex(r => r.wmPoiId === row.wmPoiId)
      if (index < 0) return
      const target = this.config.rules[index]
      this.textEditIndex = index
      this.textEditValue = target.replyText || ''
      this.textEditStoreName = target.poiName || target.wmPoiId
      this.textEditVisible = true
    },
    /** 确认：把弹窗输入写回对应 rule（仅内存，靠保存配置推送） */
    saveTextEdit () {
      if (this.textEditIndex < 0) return
      const val = this.textEditValue.trim()
      this.$set(this.config.rules[this.textEditIndex], 'replyText', val)
      this.textEditVisible = false
    },
    /** 清空（用全局默认） */
    clearTextEdit () {
      this.textEditValue = ''
    },
    /** 弹窗关闭后重置临时状态 */
    onTextEditClosed () {
      this.textEditIndex = -1
      this.textEditStoreName = ''
    },

    async fetchStatus () {
      this.statusLoading = true
      try {
        const { data: res } = await this.$http.get('yunwei/imAutoReply/status', {
          params: { brand: this.selectedBrand }
        })
        if (res.meta.status === 200) {
          this.status = res.data
        } else {
          this.$message.error(res.meta.msg || '查询状态失败')
        }
      } catch (err) {
        this.$message.error('查询状态失败')
      } finally {
        this.statusLoading = false
      }
    },

    async handleRestart () {
      try {
        await this.$confirm('确定手动重启采集端 IM 注入流程？期间约15秒无法自动回复。', '提示', { type: 'warning' })
      } catch (e) {
        return
      }
      this.restarting = true
      try {
        const { data: res } = await this.$http.post('yunwei/imAutoReply/restart', {
          brand: this.selectedBrand
        })
        if (res.meta.status === 200) {
          this.$message.success('重启指令已发送')
          setTimeout(() => this.fetchStatus(), 3000)
        } else {
          this.$message.error(res.meta.msg || '重启失败')
        }
      } catch (err) {
        this.$message.error('重启失败')
      } finally {
        this.restarting = false
      }
    },

    formatUptime (ms) {
      if (!ms) return '-'
      const s = Math.floor(ms / 1000)
      const h = Math.floor(s / 3600)
      const m = Math.floor((s % 3600) / 60)
      if (h > 0) return `${h}h${m}m`
      return `${m}m`
    },

    truncate (str, n) {
      if (!str) return ''
      return str.length > n ? str.slice(0, n) + '…' : str
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/* 顶部左右两列固定高度，内容超出时内部滚动 */
.top-card {
  height: 320px;
  overflow: hidden;
}
.top-card /deep/ .el-card__body {
  height: calc(100% - 56px);
  overflow-y: auto;
}
.search-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.search-count {
  font-size: 12px;
  color: #909399;
}
.store-count-summary {
  font-size: 13px;
  color: #909399;
  font-weight: normal;
  margin-left: 8px;
}
.stat-item {
  font-size: 14px;
}
.state-running { color: #67c23a; }
.state-starting { color: #e6a23c; }
.state-degraded { color: #f56c6c; }
.state-stopped { color: #909399; }
.stats-row {
  font-size: 13px;
  color: #606266;
  background: #f5f7fa;
  padding: 10px;
  border-radius: 4px;
}
.reply-summary {
  cursor: pointer;
  color: #606266;
  word-break: break-all;
}
.reply-summary:hover {
  color: #409eff;
}
.text-edit-hint {
  margin-top: -10px;
}
.text-edit-default {
  font-size: 12px;
  color: #909399;
}
</style>
